/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, January 2020
 */
export const PREFIX = 'aaf_';

// Focusable class names.
export const FOCUSABLE = `${PREFIX}focusable`;
export const FOCUSABLE_ROUNDED = `${PREFIX}focusable-rounded`;

// Alert class names.
export const ALERT = `${PREFIX}alert`;
export const ALERT_FULL = `${PREFIX}alert-full`;
export const ALERT_BODY = `${PREFIX}alert-body`;
export const ALERT_CLOSE = `${PREFIX}alert-close`;
export const ALERT_DEFAULT = `${PREFIX}alert-default`;
export const ALERT_INFO = `${PREFIX}alert-info`;
export const ALERT_FOCUSABLE = `${PREFIX}alert-focusable`;

// Tooltiop.
export const TOOLTIP = `${PREFIX}tooltip`;
export const TOOLTIP_CONTENT = `${PREFIX}tooltip-content`;
export const TOOLTIP_TITLE = `${PREFIX}tooltip-title`;

// List
export const LIST = `${PREFIX}list`;
export const LIST_ITEM = `${PREFIX}list-item`;

// input
export const INPUT = `${PREFIX}input`;

// Button.
// Button class names.
export const BUTTON = `${PREFIX}button`;
export const BUTTON_BLOCK = `${PREFIX}button-block`;
export const BUTTON_NO_TEXT_TRANSFORMATION = `${BUTTON}-no-text-transformation`;
export const COLORED_BUTTON = `${PREFIX}colored-button`;

// Checkbox
export const GROUP = `${PREFIX}form-group`;
export const GROUP_TEXT_DEFAULT = `${GROUP}-text`;
export const GROUP_PLACEHOLDER = `${GROUP}-placeholder`;
// `new-form-group-placeholder`

// Group input
export const GROUP_BLINK = `${GROUP}-cursor to-blink`;
export const GROUP_FOCUS = `${GROUP}-focus`;
export const GROUP_FOCUSABLE = `focusable`;
export const FOCUSED = 'focused';
export const CONTROL_FOCUSED = `${PREFIX}form-control-focused`;
export const CONTROL_SELECTED = `${PREFIX}form-control-selected`;
export const GROUP_VALUE = `${GROUP}-value`;
export const GROUP_INPUT = `${GROUP}-input`;
export const GROUP_INPUT_ELEMENT = `${GROUP}-input-element`;
export const GROUP_LABEL = `${GROUP}-label`;
export const GROUP_CHECKBOX = `${GROUP}-checkbox`;

// Avatar.
export const AVATAR = `${PREFIX}avatar`;
export const AVATAR_DEFAULT = `${PREFIX}avatar-default`;

// Grid.
export const GRID = `${PREFIX}grid`;
export const ROW = `${PREFIX}row`;
export const COLUMN = `${PREFIX}column`;

// Keyboard class names
export const KEYBOARD = `${PREFIX}keyboard`;
export const KEYBOARD_HEADER = `${KEYBOARD}-header`;
export const KEYBOARD_BODY = `${KEYBOARD}-body`;
export const KEYBOARD_FOOTER = `${KEYBOARD}-footer`;
export const KEYBOARD_ROW = `${KEYBOARD}-row`;
export const KEYBOARD_CENTER = `${KEYBOARD}-center`;
export const KEYBOARD_DEFAULT = `${KEYBOARD}-default`;
export const KEYBOARD_TABS = `${KEYBOARD}-tabs`;
export const KEYBOARD_TAB = `${KEYBOARD}-tab`;
export const KEYBOARD_TAB_IMAGE = `${KEYBOARD_TAB}-image`;
export const KEYBOARD_TAB_CONTENT = `${KEYBOARD_TAB}-content`;
export const KEYBOARD_TAB_ACTIVE = `${KEYBOARD_TAB}-active`;
export const KEYBOARD_TAB_TRANSPARENT = `${KEYBOARD_TAB}-transparent`;
export const KEYBOARD_KEY_LETTER = `${KEYBOARD}-key-letter`;
export const KEYBOARD_KEY_IMAGE = `${KEYBOARD}-key-image`;
export const KEYBOARD_KEY_ICON = `${KEYBOARD}-key-icon`;
export const KEYBOARD_FOCUSABLE_KEY = `${KEYBOARD}-focusable-key`;
export const KEYBOARD_FOCUSABLE_KEY_LETTER = `${KEYBOARD_FOCUSABLE_KEY}-letter`;
export const KEYBOARD_FOCUSABLE_KEY_ICON = `${KEYBOARD_FOCUSABLE_KEY}-icon`;

// Form.

export const FORM = `${PREFIX}form-component`;

// MusicActions
export const MUSIC_ACTIONS = `${PREFIX}music-actions`;
export const MUSIC_ACTIONS_HIDDEN = `${MUSIC_ACTIONS}-hidden`;
export const MUSIC_ACTIONS_BUTTON = `${MUSIC_ACTIONS}-button`;
export const MUSIC_ACTIONS_BUTTON_PLAY = `${MUSIC_ACTIONS_BUTTON}-play`;
export const MUSIC_ACTIONS_BUTTON_TOGGLE_FOLLOW = `${MUSIC_ACTIONS_BUTTON}-toggle-follow`;
export const MUSIC_ACTIONS_BUTTON_MORE = `${MUSIC_ACTIONS_BUTTON}-more`;
export const MUSIC_ACTIONS_BUTTON_TEXT = `${MUSIC_ACTIONS_BUTTON}-text`;
export const MUSIC_ACTIONS_BUTTON_ICON = `${MUSIC_ACTIONS_BUTTON}-icon`;

// Separator
export const SEPARATOR = `${PREFIX}separator`;

// Cover
export const COVER = `${PREFIX}cover`;

// AlbumList
export const ALBUM_LIST = `${PREFIX}album-list`;
export const ALBUM_LIST_CONTAINER = `${ALBUM_LIST}-container`;
export const ALBUM_LIST_HEADER = `${ALBUM_LIST}-header`;
export const ALBUM_LIST_BODY = `${ALBUM_LIST}-body`;
export const ALBUM_LIST_ITEM = `${ALBUM_LIST}-item`;

// PlayList
export const PLAY_LIST = `${PREFIX}play-list`;
export const PLAY_LIST_CONTAINER = `${PLAY_LIST}-container`;
export const PLAY_LIST_HEADER = `${PLAY_LIST}-header`;
export const PLAY_LIST_BODY = `${PLAY_LIST}-body`;
export const PLAY_LIST_ITEM = `${PLAY_LIST}-item`;

// Header compound
export const HEADER_COMPOUND = `${PREFIX}header-compound`;

// Key types of keyboard component
export const KEYBOARD_KEY_TYPE_LETTER = 'keyboard_key_type_letter';
export const KEYBOARD_KEY_TYPE_ICON = 'keyboard_key_type_icon';
export const KEYBOARD_KEY_TYPE_IMAGE = 'keyboard_key_type_image';

// Tab types of keyboard component

export enum KeyboardTabType {
  LETTERS = 'keyboard_tab_type_letters',
  SYMBOLS = 'keyboard_tab_type_symbols'
}

export enum KeyboardKeysType {
  LOWER_CASE_LETTERS = 'keyboard_keys_type_lower_case_letters',
  UPPER_CASE_LETTER = 'keyboard_keys_type_upper_case_letters',
  SYMBOLS = 'keyboard_keys_type_symbols'
}

export const KEYBOARD_TAB_TYPE_LETTERS = KeyboardTabType.LETTERS;
export const KEYBOARD_TAB_TYPE_SYMBOLS = KeyboardTabType.SYMBOLS;

export const KEYBOARD_SYMBOLS_KEYS = KeyboardKeysType.SYMBOLS;
export const KEYBOARD_LOWER_CASE_LETTER_KEYS = KeyboardKeysType.LOWER_CASE_LETTERS;
export const KEYBOARD_UPPER_CASE_LETTER_KEYS = KeyboardKeysType.UPPER_CASE_LETTER;

export enum KeyboardKeyType {
  LETTER = 'keyboard_key_type_letter',
  ICON = 'keyboard_key_type_icon',
  IMAGE = 'keyboard_key_type_image'
}

export interface IKeyboardKey {
  type: KeyboardKeyType;
  value: string;
}

export const KEYBOARD_DELETE_VALUE = 'delete';
export const KEYBOARD_EMPTY_VALUE = 'empty';

// Keyboard fixtures
export const LOWER_CASE_KEYS: IKeyboardKey[][] = [
  [
    {
      type: KeyboardKeyType.LETTER,
      value: 'q'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'w'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'e'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'r'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 't'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'y'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'u'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'i'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'o'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'p'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: 'a'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 's'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'd'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'f'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'g'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'h'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'j'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'k'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'l'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'ñ'
    }
  ],
  [
    {
      type: KeyboardKeyType.ICON,
      value: 'arrow-circle-up' // 'shift'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'z'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'x'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'c'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'v'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'b'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'n'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'm'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '@'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '1'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '2'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '3'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '4'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '5'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '6'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '7'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '8'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '9'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '0'
    }
  ]
];

export const UPPER_CASE_KEYS: IKeyboardKey[][] = [
  [
    {
      type: KeyboardKeyType.LETTER,
      value: 'Q'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'W'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'E'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'R'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'T'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'Y'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'U'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'I'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'O'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'P'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: 'A'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'S'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'D'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'F'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'G'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'H'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'I'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'K'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'L'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'Ñ'
    }
  ],
  [
    {
      type: KeyboardKeyType.ICON,
      value: 'arrow-circle-up' // 'shift'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'Z'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'X'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'C'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'V'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'B'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'N'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'M'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '@'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '1'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '2'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '3'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '4'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '5'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '6'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '7'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '8'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '9'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '0'
    }
  ]
];

export const SYMBOLS_KEYS: IKeyboardKey[][] = [
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '!'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '@'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '#'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '$'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '%'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '&'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '/'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '('
    },
    {
      type: KeyboardKeyType.LETTER,
      value: ')'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '='
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '?'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '¿'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '['
    },
    {
      type: KeyboardKeyType.LETTER,
      value: ']'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '{'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '}'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '-'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '_'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '.'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: ':'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: ','
    },
    {
      type: KeyboardKeyType.LETTER,
      value: ';'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '<'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '>'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '+'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '*'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '|'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '\\'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '^'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: 'ç'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '1'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '2'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '3'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '4'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '5'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '6'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '7'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '8'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '9'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '0'
    }
  ]
];

export const SPECIAL_KEYS: IKeyboardKey[][] = [
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '.com'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '.net'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '@gmail.com'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '@hotmail.com'
    }
  ],
  [
    {
      type: KeyboardKeyType.LETTER,
      value: '_'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '-'
    },
    {
      type: KeyboardKeyType.IMAGE,
      value: 'space'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '.'
    },
    {
      type: KeyboardKeyType.LETTER,
      value: '+'
    }
  ]
];

//Metrics Actions
export const CLICK = 'click';
export const LABEL_BUTTON_QUE_INCLUYE = 'que incluye';
export const METODO_DE_PAGO = 'home'


//Components
export const COMPONENT_PLAN_SELECTOR = 'plan selector';
export const COMPONENT_REGISTER = 'registro';

//Labels plan selector 
export const LABEL_INICIA_SESION = 'inicia sesion';
export const LABEL_VER_GRATIS = 'ver gratis';
export const ACTIVAR_CODIGO_PROMOCIONAL = 'activar codigo promocional';
export const SELECCION_DE_PLAN = 'seleccion de plan';
export const LABER_AGREGAR_MEDIO_DE_PAGO = 'agregar medio de pago';
export const LABER_CANCELAR_MEDIO_DE_PAGO = 'cancelar';
export const LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO = 'metodo de pago - cancelar';
export const LABEL_CONTRATA = 'contrata';
export const EVENT_ACTION_METODO_DE_PAGO = 'metodo de pago';



// WEBPACK FOOTER //
// ./src/packages/components/lib/utils/constants.ts